export default __webpack_public_path__ + "static/media/5.67d7ce1e.jpg";